interface LeafletSkeletonProps {
    count?: number
}

export const LeafletSkeleton = ({ count = 3 }: LeafletSkeletonProps) => {
    return (
        <div className="w-full grid grid-cols-1 sm:grid-cols-2 gap-4">
            {Array.from({ length: count }).map((_, i) => (
                <div key={i} className="animate-pulse">
                    <div className="bg-gray-200 aspect-[1.6] rounded-xl"></div>
                    <div className="h-6 bg-gray-200 rounded w-3/4 mt-2"></div>
                </div>
            ))}
        </div>
    )
}

